(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonder-references"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sonderCiteInit) return;
    window.__sonderCiteInit = true;

    function flipIfNeeded(cite) {
      var tip = cite.querySelector('.sonder-cite__tip');
      if (!tip) return;
      cite.removeAttribute('data-flip');
      var rect = cite.getBoundingClientRect();
      if (rect.top < 200) cite.setAttribute('data-flip', 'below');
    }

    document.addEventListener('mouseenter', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains && t.classList.contains('sonder-cite')) flipIfNeeded(t);
    }, true);

    document.addEventListener('click', function (e) {
      var num = e.target.closest && e.target.closest('.sonder-cite__num');
      var openCites = document.querySelectorAll('.sonder-cite.is-open');
      if (num) {
        var cite = num.closest('.sonder-cite');
        if (!cite.classList.contains('is-open') && window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          openCites.forEach(function (c) { if (c !== cite) c.classList.remove('is-open'); });
          flipIfNeeded(cite);
          cite.classList.add('is-open');
          return;
        }
        openCites.forEach(function (c) { if (c !== cite) c.classList.remove('is-open'); });
      } else {
        openCites.forEach(function (c) { c.classList.remove('is-open'); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.sonder-cite.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
